<div class="row">
  <mat-card appearance="outlined">
    <div class="col">
      <p>
        <ng-container *ngIf="error == false">
          <strong>¿Seguro que quiere eliminar esta relación?</strong>
        </ng-container>
        <ng-container *ngIf="error">
          <strong>Relación eliminada</strong>
        </ng-container>
      </p>
      <br />
    </div>

    <div class="text-center">
      <ng-container *ngIf="error == false">
        <button mat-stroked-button (click)="delete()">Eliminar</button>
      </ng-container>
      <button mat-stroked-button (click)="closeDialog()">Cerrar</button>
    </div>
  </mat-card>
</div>
